const state = {
  isTest : true
}

const getters = {
  getTest : (state) => state.isTest
}

export default {
  namespaced: true,
  state,
  getters
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/test.js